import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useHandleErrors = () => {
  const navigate = useNavigate();

  const handleErrors = (response) => {
    console.log("response", response);
    switch (response.status) {
      case 400:
        toast.error(`${response.data.message || "Please check your input."}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        break;
      case 401:
        toast.error(`${response.data.message || "Session Expired"}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate('/');
        localStorage.removeItem('userDetails');
        break;
      case 404:
        toast.error(`${response.data.message || "Resource not found."}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        break;
      case 409:
        toast.error(`${response.data.message || "Conflict occurred."}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        break;
      case 500:
        toast.error(`${response.data.message || "Something went wrong on our end."}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        break;
      default:
        toast.error(`${response.data.message || "An error occurred."}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        break;
    }
  };

  return handleErrors;
};

export default useHandleErrors;
